import { useState } from 'react'
import { Translate } from 'react-redux-i18n'
import { Button } from '../../../common/html/button'
import { Element } from '../../../common/html/element'
import { Image } from '../../../common/image'
import { PopupUpgrade } from '../../../userManagement/subscriptionPayment/common/popupUpgrade'
import classes from '../index.module.scss'
import screenImage from './screen.png'

export const Description = () => {
  const [isShow, setShow] = useState(false)

  const onClickUpgrade = () => {
    setShow(true)
  }

  return (
    <>
      <Element className="dFlex gap3 mt3">
        <Element className={classes.description}>
          <p>
            <Translate value="companyAnalysis.peerAnalysis.DESCRIPTION_CONTENT_1" />
          </p>
          <p className="mt2">
            <Translate value="companyAnalysis.peerAnalysis.DESCRIPTION_CONTENT_2" />
          </p>
          <ul className={classes.listItem}>
            <li>
              <Translate value="companyAnalysis.peerAnalysis.INDUSTRY" />
            </li>
            <li>
              <Translate value="companyAnalysis.peerAnalysis.REVENUE" />
            </li>
            <li>
              <Translate value="companyAnalysis.peerAnalysis.TOTAL_ASSETS" />
            </li>
            <li>
              <Translate value="companyAnalysis.peerAnalysis.YEAR_OF_OPERATION" />
            </li>
          </ul>

          <Button
            label={
              <Translate value="companyAnalysis.peerAnalysis.UPGRADE_NOW" />
            }
            className="mt3 px3 py1 textUppercase cursorPointer fw500"
            style={{
              border: 'none',
              borderRadius: 4,
              backgroundColor: '#FFCD60',
              fontSize: 20,
              color: '#191D25',
            }}
            action={onClickUpgrade}
          />
        </Element>
        <Element className={classes.imageContainer}>
          <Image
            src={screenImage}
            alt="screen"
            style={{ width: '100%', height: '100%' }}
          />
        </Element>
      </Element>
      {isShow && <PopupUpgrade isShow={isShow} setIsShow={setShow} />}
    </>
  )
}
